import { connect } from 'react-redux';
import { ca } from '@cian/analytics';

import {
  commercialSurveyRequestStart,
  closeCommercialWidgetModal,
  ISurvey,
} from '../../../serp/state/commecial_survey';

import { SurveyWidgetModal as Component } from './SurveyWidgetModal';
import { IAppState, ICommercialTrackingOfferParams } from '../../state';
import { IJsonQuery } from '../../../repositories/common/json_query';

export interface ISurveyWidgetModalStateProps {
  trackOfferPullActions?(action: string, label: string): void;
}

export const trackingHandler = (jsonQuery: IJsonQuery, params?: ICommercialTrackingOfferParams) => (
  action: string,
  label: string,
) => {
  if (params) {
    const preparedParams = Object.assign(params, {
      ea: action,
      el: label,
      searchConditions: jsonQuery,
    });

    ca('eventSite', preparedParams);
  }
};

export function mapStateToProps(state: IAppState): ISurveyWidgetModalStateProps {
  const {
    commercialTrackingOfferParams,
    filters: { jsonQuery },
  } = state;

  return {
    trackOfferPullActions: trackingHandler(jsonQuery, commercialTrackingOfferParams),
  };
}

export interface ISurveyWidgetModalDispatchProps {
  onClose(survey: ISurvey | null): void;
  onSubmit(survey: ISurvey): void;
}

export const mapDispatchToProps: ISurveyWidgetModalDispatchProps = {
  onSubmit: commercialSurveyRequestStart,
  onClose: closeCommercialWidgetModal,
};

export type TSurveyWidgetModalProps = ISurveyWidgetModalStateProps & ISurveyWidgetModalDispatchProps;

export const SurveyWidgetModal = connect(mapStateToProps, mapDispatchToProps)(Component);
